import React from 'react';
import { Paper, Progress, Group, Text, Button, Anchor } from '@mantine/core';
import classes from './BatchProcessProgressCard.module.css';
import { useTranslation } from 'react-i18next';
import { IconReload, IconX } from '@tabler/icons-react';

interface BatchProcessProgressCardProps {
  //0-100
  progress?: number;
  //current done
  current?: number;
  // total
  total?: number;
  description: string;
  label?: string; //aria-label
  onCancel?: () => void;
  onRetry?: () => void;
  onArchive?: () => void;
  /** Renders Retry but not clickable (e.g. the batch's channel credential is revoked). */
  retryDisabled?: boolean;
  /** Rendered below the card's actions — e.g. why Retry is disabled. */
  notice?: React.ReactNode;
  errored?: Array<{[x:string]: any }>;
}

export const BatchProcessProgressCard: React.FC<BatchProcessProgressCardProps> = ({ progress, current, total, description, label, onCancel, onRetry, onArchive, retryDisabled, notice, errored }) => {
    const { t } = useTranslation( 'publications' );
    const calculatedProgress = progress ?? ( current && total ? ( current / total ) * 100 : 0 );
    const erroredCount = errored?.length || 0;
    const erroredProgress = erroredCount && total ? ( erroredCount / total ) * 100 : 0 ;
    const finalProgress = ( progress ?? calculatedProgress ) - erroredProgress;
    const completed = progress ? progress >= 100 : calculatedProgress ? calculatedProgress >= 100 : false;
  return (
    <Paper
      radius="sm"
      // shadow="sm"
      withBorder
      p="sm"
      className={classes.card}
      aria-label={label ?? description}
    >
      <Group justify="space-between" mb="xs" className={classes.header}>
        <Text size={'13px'} fw={500} className={classes.description} c={'dark.4'}>
          {description}{`${erroredProgress && completed ? `: ${erroredCount} ${t( 'progress_card_errored', 'fallidas' )}` : ''}`}
        </Text>
        <Text size="sm" className={classes.percentage}>
          { progress ? progress.toFixed( 0 ) : calculatedProgress ? calculatedProgress.toFixed( 0 ) : 0}%
        </Text>
      </Group>
      <Progress.Root radius="sm" transitionDuration={200}>
        <Progress.Section value={erroredProgress} animated={!completed} color='danger'/>
        <Progress.Section value={finalProgress} animated={!completed} />
      </Progress.Root>
      {/* <Progress value={finalProgress} radius="sm" className={classes.progress} animated transitionDuration={200} /> */}
       {current !== undefined && total !== undefined && (
        <Group justify="space-between">
          <Group></Group>
          <Group>
          {onRetry && (
            <Group align='center'>
            <Anchor component="button" c="dark.3" size="xs" fw='500' mt='xs' onClick={onArchive}>
              <Group align='center' gap={4}>
                <IconX size={14}/>
                {t( 'progress_card_dismiss_button', 'No volver a mostrar este mensaje' )}
              </Group>
            </Anchor>
            <Anchor component="button" c="primary" size="xs" fw='500' mt='xs' onClick={onRetry} disabled={retryDisabled}>
              <Group align='center' gap={4}>
                <IconReload size={14}/>
                {t( 'progress_card_retry_button', 'Reintentar publicaciones fallidas' )} {`(${erroredCount})`}
              </Group>
            </Anchor>
            </Group>
            ) }
          {onCancel && <Anchor component="button" c="danger" size="xs" fw='500' mt='xs'>{t( 'progress_card_cancel_button', 'Cancelar' )}</Anchor> }
          </Group>
          <Text size="xs" mt="xs" ta="right" c="dimmed" className={classes.counter}>
              {current} / {total}
          </Text>
        </Group>

       )}
      {notice}
    </Paper>
  );
};

BatchProcessProgressCard.displayName = 'BatchProcessProgressCard';

export default BatchProcessProgressCard;